import { ToastContextProvidet } from 'shared/components/Toast/context/ToastContext';
import { combineComponents } from 'shared/utils/combineContextProviders';
import { ReactQueryClientProvider } from './ReactQueryClientProvider';

const providers: any = [ReactQueryClientProvider, ToastContextProvidet];

export const AppContextProvider = combineComponents(...providers);
